import { ApiResponse } from 'types/api';

import { apiRequest } from 'services/api/client';

export type UnsubscribeRequest = {
  first_name: string;
  last_name: string;
  email: string;
  iban_last_5: string;
};

export type PurchaseSubscriptionRequest = {
  plan_name: string;
  price: number;
};

export const subscriptionService = {
  unsubscribe(payload: UnsubscribeRequest) {
    return apiRequest<ApiResponse<Record<string, unknown>>>('/subscriptions/unsubscribe', {
      method: 'POST',
      body: payload,
    });
  },

  purchase(payload: PurchaseSubscriptionRequest) {
    return apiRequest<ApiResponse<Record<string, unknown>>>('/subscriptions/purchase', {
      method: 'POST',
      body: payload,
      auth: true,
    });
  },
};
